import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BackendService } from '@services';
import { mpiConfig } from '@app/core/config/app-config.constants';
import {
    IConsortiumApprovalResponse,
    IConsortiumMembershipResponse,
    IUpdateApprovalStatusResponse,
} from '@models/consortium/consortium.interface';
import { _getRequestOptions, _getRequestUrl } from '@services/backend/backend-utility-methods';

export interface IUpdateApprovalStatusPayload {
    taskId: string;
    gcId: string;
}

@Injectable({
    providedIn: 'root',
})
export class ConsortiumService extends BackendService {
    getApprovalRequests(gcId: string): Observable<IConsortiumApprovalResponse[]> {
        const payload = JSON.stringify({ gcId });
        return this.doPost(mpiConfig.api.consortiumApprovalRequests, payload).pipe(
            map((response) => response?.data ?? []),
        );
    }

    cancelApprovalRequest(
        requestId: number,
        payload: IUpdateApprovalStatusPayload,
    ): Observable<IConsortiumApprovalResponse | null> {
        const url = mpiConfig.api.consortiumCancelApprovalRequest(requestId);
        const options = { ..._getRequestOptions(), body: JSON.stringify(payload) };
        return this.http
            .delete(_getRequestUrl(url), options)
            .pipe(map((res: any) => res?.body?.data ?? res?.data ?? null));
    }

    updateApprovalStatus(
        requestId: number,
        taskStatus: string,
        payload: IUpdateApprovalStatusPayload,
    ): Observable<IUpdateApprovalStatusResponse | null> {
        const url = mpiConfig.api.consortiumUpdateApprovalStatus(requestId, taskStatus);
        return this.doPut(url, JSON.stringify(payload)).pipe(map((response) => response?.data ?? null));
    }

    getMembership(): Observable<IConsortiumMembershipResponse> {
        return this.doGet(mpiConfig.api.consortiumMembership).pipe(
            map((response) => response?.data ?? { consortiumMemberCount: 0 }),
        );
    }
}
